import { Search } from "lucide-react";
import { NativeSelect } from "./common";

export function applyFilters(rows, search, searchKeys, filters) {
  const q = search.trim().toLowerCase();
  return rows.filter((r) => {
    if (q && !searchKeys.some((k) => String(r[k] || "").toLowerCase().includes(q))) return false;
    return filters.every((f) => !f.value || r[f.key] === f.value);
  });
}

export function FilterBar({ search, setSearch, filters = [], testid = "filter" }) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2">
      <div className="relative w-full sm:w-64">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400" />
        <input
          data-testid={`${testid}-search-input`}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search…"
          className="h-9 w-full rounded-lg border border-zinc-200 bg-white pl-9 pr-3 text-sm placeholder:text-zinc-400 transition-colors hover:border-zinc-300 focus:border-zinc-400 focus:outline-none focus:ring-2 focus:ring-zinc-900/5"
        />
      </div>
      {filters.map((f) => (
        <NativeSelect key={f.key} testid={`${testid}-${f.key}-select`} value={f.value} onChange={f.set} options={f.options} placeholder={`All ${f.label}`} />
      ))}
    </div>
  );
}
